export const useFetchBoard = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  const fetchBoard = async (boardId: string) => {
    return await useAsyncData(
      `board-${boardId}`,
      async () => {
        const response = await $fetch(
          '/api/v1/contentful/investor/corporate-governance/board-members/board',
          {
            query: {
              locale: locale.value,
              boardId,
            },
          },
        )

        return response?.board ?? null
      })
  }

  return { fetchBoard }
}
